import PageHeader from "@/components/PageHeader";
import ListSection from "@/components/ListSection";
import AiAssistant from "@/components/AiAssistant";
import api from "@/lib/api";

const FIELDS = [
  { name: "type", label: "Typ av erfarenhet", type: "select", options: ["Anställning", "Praktik", "Volontärarbete", "Projekt", "Föreningsuppdrag", "Extraarbete", "Annat"], placeholder: "Välj typ" },
  { name: "employer", label: "Arbetsgivare / sammanhang", type: "text", placeholder: "Företag, organisation eller förening" },
  { name: "role", label: "Roll / titel / uppdrag", type: "text", placeholder: "T.ex. Lagermedarbetare, volontär, projektledare" },
  { name: "start_date", label: "Startdatum", type: "text", placeholder: "ÅÅÅÅ-MM" },
  { name: "end_date", label: "Slutdatum", type: "text", placeholder: "ÅÅÅÅ-MM eller lämna tomt" },
  { name: "current", label: "Pågår fortfarande", type: "switch" },
  { name: "tasks", label: "Arbetsuppgifter", type: "textarea", full: true, placeholder: "Vad gjorde du?" },
  { name: "responsibilities", label: "Ansvar", type: "textarea", full: true, placeholder: "Vilket ansvar hade du?" },
  { name: "achievements", label: "Prestationer", type: "textarea", full: true, placeholder: "Resultat du är stolt över" },
  { name: "projects", label: "Projekt", type: "textarea", full: true, placeholder: "Relevanta projekt" },
  { name: "systems", label: "System och verktyg som användes", type: "tags", full: true, placeholder: "Skriv och tryck Enter" },
  { name: "learned", label: "Vad du lärde dig", type: "textarea", full: true },
  { name: "enjoyed", label: "Vad du trivdes bäst med", type: "textarea", full: true },
];

export default function Erfarenheter() {
  return (
    <div>
      <PageHeader
        title="Erfarenhet"
        description="Lägg till alla dina erfarenheter här – anställningar, praktik, volontärarbete, projekt och föreningsuppdrag. Välj typ för varje post. Gamla erfarenheter tas aldrig bort; de kan förkortas i enskilda CV:n men finns alltid kvar i din Masterprofil."
      />
      <div className="flex justify-end -mt-2 mb-4">
        <AiAssistant
          triggerLabel="Fråga AI om hjälp"
          triggerTestId="erfarenhet-ai-trigger"
          title="AI-hjälp med din erfarenhet"
          intro="Jag hjälper dig sätta ord på dina arbetsuppgifter, ansvar och resultat – utifrån det du själv berättar."
          suggestions={[
            "Hur beskriver jag min erfarenhet som lagerarbetare starkt?",
            "Vilka arbetsuppgifter är värda att lyfta fram?",
            "Hjälp mig formulera en prestation jag är stolt över",
          ]}
          loadHistory={async () => (await api.get("/assistant/advice/erfarenhet")).data}
          send={async (message) => (await api.post("/assistant/advice", { topic: "erfarenhet", message })).data}
        />
      </div>
      <ListSection
        endpoint="experiences"
        fields={FIELDS}
        addLabel="Lägg till ytterligare erfarenhet"
        emptyText="Inga erfarenheter tillagda ännu."
        summary={(it) => ({
          title: it.role,
          subtitle: [it.employer, it.type].filter(Boolean).join(" · "),
          meta: `${it.start_date || "?"} – ${it.current ? "Nuvarande" : it.end_date || "?"}`,
          body: it.tasks,
        })}
      />
    </div>
  );
}
